import React from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
	FaFacebook,
	FaInstagram,
	FaWhatsapp,
	FaPhone,
	FaEnvelope,
	FaMapMarkerAlt,
} from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
	return (
		<>
			<Helmet>
				<meta
					name="description"
					content="Contáctanos para encontrar la mejor propiedad en Chajarí. Ubicación, teléfono y redes sociales de Inmobiliaria Percara."
				/>
				<meta
					name="keywords"
					content="inmobiliaria, contacto inmobiliaria, propiedades en Chajarí, atención al cliente, bienes raíces"
				/>
				<meta name="author" content="Inmobiliaria Percara" />
			</Helmet>

			<motion.div
				id="Contact"
				className="contact-links"
				initial={{ opacity: 0, y: 30 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1 }}
			>
				<a
					href="https://www.google.com/maps/place/Salvarredy+1919,+Chajar%C3%AD,+Entre+R%C3%ADos"
					className="contact-btn location"
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Ver ubicación en Google Maps"
				>
					<FaMapMarkerAlt /> Ubicación
				</a>
				<a
					href="tel:+5493456553422"
					className="contact-btn phone"
					aria-label="Llamar a Inmobiliaria Percara"
				>
					<FaPhone /> Llamar
				</a>
				<a
					href="mailto:Inmobiliariapercara@hotmail.com"
					className="contact-btn email"
					aria-label="Enviar un correo electrónico"
				>
					<FaEnvelope /> Email
				</a>
				<a
					href="https://wa.me/+5493456553422"
					className="contact-btn whatsapp"
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Enviar mensaje por WhatsApp"
				>
					<FaWhatsapp /> WhatsApp
				</a>
				<a
					href="https://www.instagram.com/percaranegociosinmobiliarios"
					className="contact-btn instagram"
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Visitar perfil de Instagram"
				>
					<FaInstagram /> Instagram
				</a>
				<a
					href=" https://www.facebook.com/inmobiliariapercara"
					className="contact-btn facebook"
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Visitar perfil de Facebook"
				>
					<FaFacebook /> Facebook
				</a>
			</motion.div>
		</>
	);
};

export default Contact;